// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"78623b4e","391":"7a42c82c","805":"0e4cbc04"}[chunkId] + ".chunk.css";
};